// Файл interface_profile_request.js
/**
 * Модуль запрашивает настройки профиля интерфейса.
 * Он согласует получение и установку настроек пользователя.
 * Код использует существующие компоненты и зависимости этого раздела.
 * Его функции участвуют в работе соответствующей страницы или сервиса.
 */


import {
    install_navigation_settings,
} from '../../components/TabWidget/navigation_settings_store';
import {
    install_interface_customization_settings,
} from
    '../../shared_code/interface_customization/interface_customization_store';
import {
    install_table_visible_columns,
} from '../../shared_code/interface_customization/table_column_settings_store';
import {
    install_table_column_widths,
} from '../../shared_code/interface_customization/table_column_widths_store';
import {
    request_interface_profile,
} from '../api_parts/interface_profile_transport';



const PROFILE_CACHE_MS = 2500;
let profile_request = null;
let cached_profile = null;
let cached_at = 0;

const install_profile = (response = {}) => {
    install_interface_customization_settings(response?.settings || {});
    install_navigation_settings(response?.navigation_settings || {});
    if (
        response?.settings
        && Object.prototype.hasOwnProperty.call(
            response.settings,
            'table_visible_columns',
        )
    ) {
        install_table_visible_columns(
            response.settings.table_visible_columns || {}
        );
    }

    if (
        Object.prototype.hasOwnProperty.call(
            response,
            'table_column_widths',
        )
    ) {
        install_table_column_widths(
            response.table_column_widths || {}
        );
    }

    return response;
};

export const load_interface_customization_profile = (
    api_service,
    force = false,
) => {
    const cache_is_fresh = (
        cached_profile
        && Date.now() - cached_at < PROFILE_CACHE_MS
    );

    if (!force && cache_is_fresh) {
        return Promise.resolve(install_profile(cached_profile));
    }

    if (profile_request) {
        return profile_request;
    }

    profile_request = request_interface_profile(
        api_service,
    ).then((response) => {
        cached_profile = response || {};
        cached_at = Date.now();

        return install_profile(cached_profile);
    }).finally(() => {
        profile_request = null;
    });

    return profile_request;
};

export const load_interface_customization_settings = (
    api_service,
    force = false,
) => load_interface_customization_profile(
    api_service,
    force,
).then((response) => response?.settings || {});
